import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const getSubjectDescription = ({
  description,
  slug,
}: {
  description?: string;
  slug?: string;
}) => {
  if (description) {
    return description;
  }

  switch (slug) {
    case "art":
      return i18n.t("subjects.art.description", { ns: COMMON_NS });
    case "computing":
      return i18n.t("subjects.computing.description", { ns: COMMON_NS });
    case "design-tech":
      return i18n.t("subjects.design-tech.description", { ns: COMMON_NS });
    case "english":
      return i18n.t("subjects.english.description", { ns: COMMON_NS });
    case "geography":
      return i18n.t("subjects.geography.description", { ns: COMMON_NS });
    case "french":
      return i18n.t("subjects.french.description", { ns: COMMON_NS });
    case "history":
      return i18n.t("subjects.history.description", { ns: COMMON_NS });
    case "mathematics":
      return i18n.t("subjects.maths.description", { ns: COMMON_NS });
    case "music":
      return i18n.t("subjects.music.description", { ns: COMMON_NS });
    case "physical-education":
      return i18n.t("subjects.physical-education.description", {
        ns: COMMON_NS,
      });
    case "pshe":
      return i18n.t("subjects.pshe.description", { ns: COMMON_NS });
    case "religion-worldviews":
      return i18n.t("subjects.religion-worldviews.description", {
        ns: COMMON_NS,
      });
    case "science":
      return i18n.t("subjects.science.description", { ns: COMMON_NS });
    case "spanish":
      return i18n.t("subjects.spanish.description", { ns: COMMON_NS });
    case "spelling":
      return i18n.t("subjects.spelling.description", { ns: COMMON_NS });
    case "handwriting":
      return i18n.t("subjects.handwriting.description", { ns: COMMON_NS });
    default:
      return i18n.t("subjects.not-found.description", {
        slug,
        ns: COMMON_NS,
      });
  }
};
